// extracted by mini-css-extract-plugin
module.exports = {"descriptionBlock":"styles_descriptionBlock__h2nYE","description":"styles_description__4E88z"};